__webpack_require__.p = "/views-hide-header-on-scroll/account-setup/";